<div class="scene">

  <!-- ================= PANNEAU GAUCHE : affiche cinematique ================= -->
  <div class="affiche-panneau">
    <div class="affiche-photo"></div>
    <div class="affiche-voile"></div>

    <div class="affiche-entete">
      <div class="monogramme">FIS</div>
    </div>

    <div class="affiche-bas">
      <span class="affiche-eyebrow">Théâtre de Sidi Dhaher — Sousse</span>
      <h1 class="affiche-titre">Festival International<br><em>de Sousse</em></h1>
      <div class="affiche-trait"></div>
      <span class="affiche-edition">Back-office — accès réservé à l'organisation</span>
    </div>
  </div>

  <!-- ================= PANNEAU DROIT : formulaire ================= -->
  <div class="connexion-panneau">
    <form class="connexion-carte" (ngSubmit)="seConnecter()">
      <span class="connexion-eyebrow">{{ 'admin.login.soustitre' | traduire }}</span>
      <h2>{{ 'admin.login.titre' | traduire }}</h2>

      <div class="champ">
        <label>{{ 'admin.login.identifiant' | traduire }}</label>
        <input type="text" [(ngModel)]="username" name="username" required autocomplete="username">
      </div>

      <div class="champ">
        <label>{{ 'admin.login.motdepasse' | traduire }}</label>
        <input type="password" [(ngModel)]="password" name="password" required autocomplete="current-password">
      </div>

      <!-- Champ piege invisible : un robot le remplit, un humain ne le voit meme pas -->
      <div class="honeypot" aria-hidden="true">
        <label for="siteWeb">Site web</label>
        <input type="text" [(ngModel)]="champPiege" name="siteWeb" id="siteWeb" tabindex="-1" autocomplete="off">
      </div>

      <div class="champ champ-captcha">
        <label>{{ 'admin.login.verification' | traduire }}</label>
        <div class="captcha-zone">
          <canvas #captchaCanvas width="170" height="52"></canvas>
          <button type="button" class="captcha-refresh" (click)="genererCaptcha()" title="Générer un autre code">↻</button>
        </div>
        <input type="text" [(ngModel)]="reponseCaptcha" name="reponseCaptcha" [placeholder]="'admin.login.recopier' | traduire" required>
      </div>

      <p class="erreur" *ngIf="messageErreur">{{ messageErreur }}</p>
      <p class="blocage" *ngIf="messageBlocage">{{ messageBlocage }}</p>

      <button type="submit" class="btn-connexion" [disabled]="boutonDesactive">
        {{ 'admin.login.connexion' | traduire }}
      </button>

      <a routerLink="/" class="retour-site">← Retour au site</a>
    </form>
  </div>

</div>
